import CategoryPageView from "@/components/feature/CategoryPageView";

export default function NewsPage() {
  return <CategoryPageView categoryKey="news" />;
}